<script lang="ts">
	import { Icon } from '@repo/commons/components'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'

	interface Props {
		role: string
	}

	let { role }: Props = $props()

	const roleClassName: Record<typeof role, string> = {
		USER: 'user-avatar',
		ASSISTANT: 'assistant-avatar',
		SYSTEM: 'system-avatar'
	}

	const roleIcon: Record<typeof role, IconName> = {
		USER: 'user',
		ASSISTANT: 'ai',
		SYSTEM: 'code'
	}
</script>

<span class={['avatar', roleClassName[role]]}>
	<Icon name={roleIcon[role]} />
</span>

<style>
	.avatar {
		@apply flex items-center justify-center h-12 w-12 min-w-12 rounded-3xl text-white border border-[#003A661A];
	}
	.avatar.user-avatar {
		@apply bg-se-green-1;
	}
	.avatar.assistant-avatar {
		@apply bg-brand;
	}
	.avatar.system-avatar {
		@apply bg-se-grey-1;
	}
</style>
